module.exports = __webpack_public_path__ + "assets/photos/memories/frame-5--83fb4bf1900710714f96f5895bd36c44.jpg";